import React from 'react';
import { obterContratoPeloNumero } from '../actions/ContratoActions';
import { deletarPublicacao, editarPublicacao } from '../actions/PublicacaoActions';
import { connect } from 'react-redux';
import ConfirmationModal from '../components/ConfirmationModal';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import axios from 'axios';
import { REQUEST_URL } from '../config/urls'

class Publicacoes extends React.Component {
  state = {
    contrato: "",
    publicacao: null,
    publicacoes: [],
    ultimasPubs: [],
    temPubs: true
  }
  componentDidMount() {
    if (this.props.contrato) {
      this.setState({ publicacoes: this.props.contrato.publicacoes, temPubs: true, contrato: this.props.contrato.numero });
    }
    this.buscarUltimasPublicacoes();
  }
  buscarUltimasPublicacoes() {
    axios.get(`${REQUEST_URL}/publicacoes?filter={"limit":5,"order":"dataPublicacao DESC"}`).then(async (response) => {
      let ultimasPubs = response.data;
      for (let i = 0; i < ultimasPubs.length; i++) {
        let p = ultimasPubs[i];
        let response = await axios.get(`${REQUEST_URL}/contratos/${p.contrato}`);
        ultimasPubs[i].contrato = response.data;
      }
      this.setState({ ultimasPubs });
    })
  }
  buscarPublicacoes(event) {
    event.preventDefault();
    if (this.state.contrato && this.state.contrato > 0) {
      this.props.obterContratoPeloNumero(this.state.contrato).then(() => {
        if (this.props.contrato) {
          this.setState({ publicacoes: this.props.contrato.publicacoes, temPubs: true });
        } else {
          this.setState({ temPubs: false, publicacoes: [] })
        }
      });
    } else {
      if (this.state.contrato) {
        toast.error("O número do contrato deve ser maior que 0");
      } else {
        toast.error("Digite o número do contrato antes de buscar");
      }
    }
  }

  deletarPublicacao() {
    this.props.deletarPublicacao(this.state.publicacao.id).then(() => {
      this.props.obterContratoPeloNumero(this.state.contrato).then(() => {
        this.setState({ publicacoes: this.props.contrato.publicacoes });
      });
    });
  }

  reabrirPublicacao() {
    this.props.editarPublicacao(this.state.publicacao.id, { dataAprovacao: null, status: "aguardando", bloqueada: false }).then(() => {
      this.props.obterContratoPeloNumero(this.state.contrato).then(() => {
        this.setState({ publicacoes: this.props.contrato.publicacoes });
      });
    });
  }

  _renderUltimasPubs() {
    return (
      <div className="table-responsive" style={{ marginTop: 30 }}>
        <h3>Ultimas Publicações</h3>
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Número</th>
              <th>Contrato</th>
              <th>Tipo</th>
              <th>Data da Publicação</th>
              <th>Data de Finalização</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.ultimasPubs ? this.state.ultimasPubs.map(publicacao => (
                <tr key={publicacao.id}>
                  <td>{publicacao.id}</td>
                  <td>{publicacao.contrato.numero}</td>
                  <td>{publicacao.tipo}</td>
                  <td>{new Date(publicacao.dataPublicacao).toLocaleDateString("pt-BR", {timeZone: "UTC"})}</td>
                  <td>{publicacao.dataAprovacao ? new Date(publicacao.dataAprovacao).toLocaleDateString("pt-BR", {timeZone: "UTC"}) : "Publicação pendente"}</td>
                  <td>{publicacao.status}</td>
                  <td>
                    <Link title="entrar" alt="Ir para a publicação" to={`/publicacoes/${publicacao.id}`} style={{ margin: 10 }} target="_blank"><i className="fa fa-share"></i></Link>
                    {
                      publicacao.visivel ?
                        <a title="deixar invisivel" alt="Deixar a publicação invisível" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { visivel: false }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-eye"></i></a>
                      : <a title="deixar visivel" alt="Deixar a publicação visível" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { visivel: true }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-eye-slash"></i></a>
                    }
                    {
                      !publicacao.bloqueada ?
                        <a title="bloquear" alt="Bloquear publicação" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { bloqueada: true }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-unlock-alt"></i></a>
                      : <a title="desbloquear" alt="Desbloquear publicação" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { bloqueada: false }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-lock"></i></a>
                    }
                    <a title="deletar" alt="Deletar publicação" style={{ margin: 10 }} onClick={() => { this.refs.modalDeletar.open(); this.setState({ publicacao }) }}><i className="fa fa-trash-o"></i></a>
                    {
                      !publicacao.dataAprovacao ?
                        <a title="reabrir" alt="Reabrir publicação" style={{ margin: 10 }} onClick={() => { this.refs.modalReabrir.open(); this.setState({ publicacao }) }}><i className="fa fa-undo"></i></a>
                      : null
                    }
                  </td>
                </tr>
              )) : null
            }
          </tbody>
        </table>
      </div>
    )
  }
  _renderTablePublicacoes() {
    return (
      <div className="table-responsive" style={{ marginTop: 30 }}>
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Número</th>
              <th>Tipo</th>
              <th>Data da Publicação</th>
              <th>Data de Finalização</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {
              !this.state.temPubs ?
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>O Contrato não existe ou não possui nenhuma publicação</td>
                </tr>
                : null
            }
            {
              this.state.publicacoes ? 
                this.state.publicacoes.map(publicacao => (
                  <tr key={publicacao.id}>
                    <td>{publicacao.id}</td>
                    <td>{publicacao.tipo}</td>
                    <td>{new Date(publicacao.dataPublicacao).toLocaleDateString("pt-BR", {timeZone: "UTC"})}</td>
                    <td>{publicacao.dataAprovacao ? new Date(publicacao.dataAprovacao).toLocaleDateString("pt-BR", {timeZone: "UTC"}) : "Publicação pendente"}</td>
                    <td>{publicacao.status}</td>
                    <td>
                      <Link title="entrar" alt="Ir para a publicação" to={`/publicacoes/${publicacao.id}`} style={{ margin: 10 }} target="_blank"><i className="fa fa-share" ></i></Link>
                      {
                        publicacao.visivel ?
                          <a title="deixar invisivel" alt="Deixar a publicação invisível" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { visivel: false }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-eye"></i></a>
                        : <a title="deixar visivel" alt="Deixar a publicação visível" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { visivel: true }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-eye-slash"></i></a>
                      }
                      {
                        !publicacao.bloqueada ?
                          <a title="bloquear" alt="Bloquear publicação" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { bloqueada: true }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-unlock-alt"></i></a>
                        : <a title="desbloquear" alt="Desbloquear publicação" style={{ margin: 10 }} onClick={() => this.props.editarPublicacao(publicacao.id, { bloqueada: false }).then(() => this.props.obterContratoPeloNumero(this.state.contrato).then(() => { this.setState({ publicacoes: this.props.contrato.publicacoes }) }))}><i className="fa fa-lock"></i></a>
                      }
                      <a title="deletar" alt="Deletar publicação" style={{ margin: 10 }} onClick={() => { this.refs.modalDeletar.open(); this.setState({ publicacao }) }}><i className="fa fa-trash-o"></i></a>
                      {
                        publicacao.dataAprovacao ?
                          <a title="reabrir" alt="Reabrir publicação" style={{ margin: 10 }} onClick={() => { this.refs.modalReabrir.open(); this.setState({ publicacao }) }}><i className="fa fa-undo"></i></a>
                        : null
                      }
                    </td>
                  </tr>
                )) 
              : null
            }
          </tbody>
        </table>
      </div>
    )
  }
  render() {
    return (
      <div className="box">
        <ConfirmationModal ref="modalDeletar" confirmButtonStyle="btn-danger" title="Deletar publicação" confirmButton="Deletar publicação" body="Tem certeza que deseja deletar esta publicação?" onConfirm={this.deletarPublicacao.bind(this)} />
        <ConfirmationModal ref="modalReabrir" confirmButtonStyle="btn-danger" title="Reabrir publicação" confirmButton="Reabrir publicação" body="Tem certeza que deseja reabrir esta publicação?" onConfirm={this.reabrirPublicacao.bind(this)} />
        <div className="box-body">
          {this._renderUltimasPubs()}
          <h3>Buscar Publicação</h3>
          <form onSubmit={this.buscarPublicacoes.bind(this)}>
            <div className="input-group">
              <input type="number" value={this.state.contrato} placeholder="Número do contrato" min="0" onChange={(event) => this.setState({ contrato: event.target.value })} className="form-control" />
              <div className="input-group-btn">
                <button type="submit" className="btn btn-flat btn-primary">Buscar contrato</button>
              </div>
            </div>
          </form>
          {this._renderTablePublicacoes()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico
  }
}

export default connect(mapStateToProps, { obterContratoPeloNumero, deletarPublicacao, editarPublicacao })(Publicacoes);



// WEBPACK FOOTER //
// ./src/views/Publicacoes.js